import ERROR_DOMAIN from 'constants/errors';

const { TELEMETRY } = ERROR_DOMAIN;

export const getCurrentTimestamp = () => Math.floor(Date.now());

export const getOperatingSystem = (userAgent: any) => {
  if (userAgent.includes('like Mac')) return 'iOS';
  if (userAgent.includes('Win')) return 'Windows';
  if (userAgent.includes('Mac')) return 'MacOS';
  if (userAgent.includes('X11')) return 'UNIX';
  if (userAgent.includes('Linux')) return 'Linux';
  if (userAgent.includes('Android')) return 'Android';
  return 'Unknown OS';
};

export const getDeviceType = (userAgent: string) => {
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) return 'Tablet';
  if (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile/.test(userAgent)) return 'Mobile';
  return 'Desktop';
};

export const getBrowserDetails = (userAgent: any) => {
  const browserMatch = userAgent.match(/(Chrome|Firefox|Safari|Edge)\/([\d.]+)/);
  return browserMatch ? {
    browserName: browserMatch[1],
    browserVersion: browserMatch[2],
  } : {
    browserName: 'Not recognized',
    browserVersion: userAgent,
  };
};

export const getScreenInfo = () => ({
  deviceWidth: window.screen.width,
  deviceHeight: window.screen.height,
});

export const generateTelemetrySessionID = () => Math.random().toString(36).substr(2, 9) + Date.now().toString(36);

export const getOrGenerateTelemetrySessionID = () => {
  let telemetrySessionID = localStorage.getItem('telemetrySessionID');
  if (!telemetrySessionID) {
    telemetrySessionID = generateTelemetrySessionID();
    localStorage.setItem('telemetrySessionID', telemetrySessionID);
  }
  return telemetrySessionID;
};

export const setNewTelemetrySessionID = () => {
  const newTelemetrySessionID = generateTelemetrySessionID();
  localStorage.setItem('telemetrySessionID', newTelemetrySessionID);
  return newTelemetrySessionID;
};

export const getUserLocation = async (): Promise<{latitude: number, longitude: number, accuracy: number}> => new Promise((resolve, reject) => {
  if (!navigator.geolocation) {
    reject(new Error(`${TELEMETRY.BROWSER_GEOLOCATION}`));
  } else {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
        });
      },
      (error) => {
        reject(error);
      },
    );
  }
});
